export enum DropdownMenuTriggerTheme {
  White = 'white',
  Black = 'black',
}
